import isEmpty from 'lodash/isEmpty'
import { ANSWER } from '@/config/tracker'

const PRODUCTION_VALUES = {
  610: ['SSPB01Produkt', 'SSHB01Produkt'],
  310: ['H3SL04Produkt', 'AB304Produkt', 'AB04Produkt', 'AB404Produkt']
}

export const TrackerUtil = {
  computeProductsValue(persons) {
    return persons.reduce((acc, person) => {
      const personProducts = this.getPersonProducts(person)
      acc += this.getProductionValue(personProducts)
      return acc
    }, 0)
  },

  getBooleanAnswer(value) {
    return value ? ANSWER.YES : ANSWER.NO
  },

  getPersonProducts(person) {
    return Object.entries(person?.products?.products || [])
      .map(([id, product]) => {
        return ({
          id,
          selected: product.selected,
          selectedOption: product.prices.find(price => price.selected)
        })
      })
      .filter(p => p.selected)
  },
  getProductCategory(productsStructure, productId) {
    if (!productsStructure) {
      return
    }

    const getParentId = (structure, parentKey, childKey, childId) => Object.values(structure[parentKey]).filter(parent => parent[childKey].includes(childId))[0]?.id

    const groupId = getParentId(productsStructure, 'groups', 'products', productId)
    return getParentId(productsStructure, 'categories', 'groups', groupId)
  },
  getProductionValue(products) {
    let productList = products

    if (!Array.isArray(products)) {
      productList = Object.keys(products).map(k => ({ id: k }))
    }

    if (productList.length === 0) {
      return 0
    }

    for (let product of productList) {
      for (let value of Object.keys(PRODUCTION_VALUES)) {
        if (PRODUCTION_VALUES[value].includes(product.id)) {
          return parseInt(value)
        }
      }
    }
    return 50
  },
  getProducts(persons, productsStructure) {
    const products = persons.reduce((acc, person) => {
      const personProducts = this.getPersonProducts(person)
      const personPrice = this.getProductionValue(personProducts)

      personProducts.forEach(product => {
        // Set quantity
        if (Object.keys(acc).find(p => p === product.id)) {
          acc[product.id].quantity += 1
        } else {
          acc[product.id] = {
            name: product.id,
            quantity: 1
          }
        }

        // Set price to product with highest value
        acc[product.id].price = this.getProductionValue([{ id: product.id }]) === personPrice ? personPrice : 0

        // Temporarily add persons ref
        if (acc[product.id].persons) {
          acc[product.id].persons.push(person.id)
        } else {
          acc[product.id].persons = [person.id]
        }
      })

      return acc
    }, {})

    Object.keys(products).forEach(id => {
      delete products[id].persons
    })

    return Object.values(products)
      .map(p => {
        const category = this.getProductCategory(productsStructure, p.name) || ''
        return `${category};${p.name};${p.quantity};${p.price}`
      })
      .join(',')
  },
  hasMultiYearProducts(persons) {
    return persons.some(person => {
      const personProducts = this.getPersonProducts(person)
      return personProducts.some(product => {
        const duration = product?.selectedOption?.duration
        return duration && duration !== 1
      })
    })
  },
  isCollective(basket) {
    return !isEmpty(basket.collective)
  }
}
